import Joi from 'joi';

/**
 * Schema for renewed filebox record validation.
 */
export const renewFileboxSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
